import { FunctionComponent, ReactNode } from "react";
import { UiDataContext } from "./context";
import { UiData } from "./ui-data";

export type UiDataProviderProps = {
	data: UiData;
	children?: ReactNode;
};

export const UiDataProvider: FunctionComponent<UiDataProviderProps> = ({
	data,
	children,
}) => <UiDataContext.Provider value={data}>{children}</UiDataContext.Provider>;
